import { createApp,  provide, h } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";

const baseUrl = process.env.VUE_APP_BASE_URL;

const appInstance = createApp({
    setup() {
      provide('baseUrl', baseUrl);
    },
    render: () => h(App)
  });
  
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.mount("#app");
